"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayCategory = void 0;
var GameplayCategory;
(function (GameplayCategory) {
    GameplayCategory["CharacterRecognition"] = "Character Recognition";
    GameplayCategory["ImageRecognition"] = "Image Recognition";
    GameplayCategory["AudioRecognition"] = "Audio Recognition";
    GameplayCategory["FillInTheBlank"] = "Fill in the blank";
    GameplayCategory["SentenceFormation"] = "Sentence Formation";
    GameplayCategory["Numbers"] = "Numbers";
    GameplayCategory["VideoRecognition"] = "Video Recognition";
})(GameplayCategory = exports.GameplayCategory || (exports.GameplayCategory = {}));
